import locale from './locale'

export const formatPrice = (number) => {
    return new Intl.NumberFormat(locale.get(), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number)
}

export const formatDate = (date) => {
    return new Intl.DateTimeFormat(locale.get(), {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(new Date(date))
}
